import React from 'react';

const Column = (props) => {
    return (
        <td className="Content" style={props.style}>
            {props.children}
        </td>
    )
};

export default React.memo(Column);